(() => {
  'use strict';
  let savedScroll = 0;
  let pendingScroll = null;
  let locked = false;
  const dialogs = [...document.querySelectorAll('dialog')];
  const focusBefore = new WeakMap();
  const syncScrollLock = () => {
    const open = dialogs.some(d => d.open);
    if (open && !locked) {
      savedScroll = pendingScroll ?? window.scrollY;
      pendingScroll = null;
      document.body.style.position = 'fixed';
      document.body.style.top = `-${savedScroll}px`;
      document.body.style.width = '100%';
      locked = true;
    } else if (!open && locked) {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      locked = false;
      window.scrollTo({top: savedScroll, behavior: 'instant'});
      const restoreY = savedScroll;
      requestAnimationFrame(() => {
        if (!locked) window.scrollTo({top: restoreY, behavior: 'instant'});
      });
    }
  };
  const movie = document.querySelector('[data-nh-video]');
  const setStep = (index, play = true) => {
    if (!movie) return;
    movie.pause();
    movie.src = movie.getAttribute(`data-src-${index}`);
    movie.poster = movie.getAttribute(`data-poster-${index}`);
    movie.load();
    document.querySelectorAll('[data-nh-step]').forEach(b => b.setAttribute('aria-pressed',String(b.dataset.nhStep === String(index))));
    if (play) movie.play().catch(() => { /* Native controls remain available when iOS blocks playback. */ });
  };
  document.querySelectorAll('[data-nh-open]').forEach(button => {
    button.addEventListener('click', () => {
      const dialog = document.getElementById(button.dataset.nhOpen);
      if (!dialog) return;
      focusBefore.set(dialog,button);
      pendingScroll = window.scrollY;
      dialog.showModal();
      button.setAttribute('aria-expanded','true');
      syncScrollLock();
      if (dialog.id === 'nh-search') document.getElementById('nh-search-input').focus();
      if (dialog.id === 'nh-video') {
        if (!movie.getAttribute('src')) setStep(0);
        else movie.play().catch(() => {});
      }
    });
  });
  document.querySelectorAll('[data-nh-step]').forEach(b => b.addEventListener('click',() => setStep(b.dataset.nhStep)));
  const finishClose = dialog => {
    if (dialog.id === 'nh-video') movie.pause();
    const trigger = focusBefore.get(dialog);
    trigger?.setAttribute('aria-expanded','false');
    syncScrollLock();
    trigger?.focus({preventScroll:true});
  };
  const closeDialog = dialog => {dialog.close();finishClose(dialog);};
  document.querySelectorAll('.nh-dialog').forEach(dialog => {
    dialog.querySelector('[data-nh-close]').addEventListener('click', () => closeDialog(dialog));
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeDialog(dialog);
    });
    dialog.addEventListener('close',() => finishClose(dialog));
    dialog.querySelectorAll('nav a').forEach(a => a.addEventListener('click',() => closeDialog(dialog)));
  });
  const observer = new MutationObserver(syncScrollLock);
  dialogs.forEach(d => observer.observe(d,{attributes:true,attributeFilter:['open']}));
  matchMedia('(min-width:768px)').addEventListener('change',event => {
    if (event.matches) document.getElementById('nh-menu')?.close();
  });
  document.addEventListener('visibilitychange',() => {if(document.hidden) movie?.pause();});
  window.addEventListener('pagehide',() => {movie?.pause();dialogs.forEach(d=>{if(d.open)d.close();});syncScrollLock();});
  document.documentElement.dataset.nhReady = 'v1';
})();
